import { GroupBase, StylesConfig } from 'react-select';

const WARNING_COLOR = 'var(--color-warning)';
const WARNING_BACKGROUND_COLOR = 'var(--color-warning-background)';

const multiValueStyles = {
  multiValue: (baseStyle: any) => ({
    ...baseStyle,
    background:
      'linear-gradient(90deg, #ded9f5 0%, #cbe1fe 47.52%, #c6cff2 100%)',
    borderRadius: '12px',
  }),
  multiValueRemove: (baseStyle: any) => ({
    ...baseStyle,
    color: '#4a90e2',
    svg: {
      fill: '#4a90e2',
    },
    ':hover': {
      backgroundColor: 'transparent',
      color: '#4a90e2',
      svg: {
        fill: '#4a90e2',
      },
    },
  }),
};

export const defaultStyle: StylesConfig<any, boolean, GroupBase<any>> = {
  ...multiValueStyles,
  container: (basestyle: any) => ({
    ...basestyle,
  }),
  control: (basestyle: any, state: any) => ({
    ...basestyle,
    borderColor: state.isFocused
      ? '#8b27cad8 !important'
      : '#d2d4d7 !important',
    boxShadow: 'inset 1px 1px 1px 1px rgba(0, 0, 0, 0.06)',
    color: '#4b5055',
    backgroundColor: '#f7f7f9',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '1.2rem',
    fontFamily: 'Open Sans, sans-serif',
    fontStyle: 'normal',
    color: '#4b5055',
    fontWeight: state.isFocused ? '600' : '400',
    backgroundColor: state.isFocused ? '#c6dbf6' : '#ffffff',
  }),
  input: (basestyle: any) => ({
    ...basestyle,
    color: '#4b5055',
  }),
  dropdownIndicator: (basestyle: any, state: { isFocused: any }) => ({
    ...basestyle,
    borderColor: state.isFocused
      ? '#8b27cad8 !important'
      : '#d2d4d7 !important',
    boxShadow: 'inset 1px 1px 1px 1px rgba(0, 0, 0, 0.06)',
    WebkitBoxShadow: '0px 1px 1px rgba(221, 221, 221, 0.6) inset;',
    color: '#c6dbf6',
    backgroundColor: '#f7f7f9',
    paddingLeft: '4px',
  }),
  clearIndicator: (baseStyle: any) => ({
    ...baseStyle,
    color: '#c6dbf6',
    backgroundColor: '#f7f7f9',
    paddingRight: '4px',
    paddingLeft: '4px',
  }),

  menu: (baseStyle: any) => ({
    ...baseStyle,
    zIndex: 10,
  }),

  menuList: (baseStyle: any) => ({
    ...baseStyle,
    fontfamily: 'Open Sans, sans-serif',
    fontsize: '0.6px',
    fontweight: '400',
  }),
};

export const errorStyle: StylesConfig<any, boolean, GroupBase<any>> = {
  ...multiValueStyles,
  control: (basestyle: any) => ({
    ...basestyle,
    borderColor: '#e24a4a !important',
    boxShadow: 'inset 1px 1px 1px 1px rgba(0, 0, 0, 0.06)',
    WebkitBoxShadow: '1px 1px 1px rgba(221, 221, 221, 0.6) inset;',
    color: '#4b5055',
    backgroundColor: '#fbe4e4',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '1.2rem',
    fontFamily: 'Open Sans, sans-serif',
    fontStyle: 'normal',
    color: '#4b5055',
    fontWeight: state.isFocused ? '600' : '400',
    backgroundColor: state.isFocused ? '#c6dbf6' : '#ffffff',
  }),
  menu: (baseStyle: any) => ({
    ...baseStyle,
    zIndex: 10,
  }),
};

export const warningStyle: StylesConfig<any, boolean, GroupBase<any>> = {
  ...multiValueStyles,
  control: (basestyle: any) => ({
    ...basestyle,
    borderColor: `${WARNING_COLOR} !important`,
    boxShadow: 'inset 1px 1px 1px 1px rgba(0, 0, 0, 0.06)',
    WebkitBoxShadow: '1px 1px 1px rgba(221, 221, 221, 0.6) inset;',
    color: '#4b5055',
    backgroundColor: WARNING_BACKGROUND_COLOR,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '1.2rem',
    fontFamily: 'Open Sans, sans-serif',
    fontStyle: 'normal',
    color: '#4b5055',
    fontWeight: state.isFocused ? '600' : '400',
    backgroundColor: state.isFocused ? '#c6dbf6' : '#ffffff',
  }),
  menu: (baseStyle: any) => ({
    ...baseStyle,
    zIndex: 10,
  }),
};

export const disabledStyle: StylesConfig<any, boolean, GroupBase<any>> = {
  ...multiValueStyles,
  control: (basestyle: any) => ({
    ...basestyle,
    borderColor: '#ccc',
    boxShadow: 'inset 1px 1px 1px 1px rgba(0, 0, 0, 0.06)',
    WebkitBoxShadow: '1px 1px 1px rgba(221, 221, 221, 0.6) inset;',
    color: '#4b5055',
    backgroundColor: '#eee',
  }),
};
